(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6961],{

/***/ 37296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(24782);

/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meta/scribe",
      function () {
        return __webpack_require__(74276);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ViennaScribeHome; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(37296);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(38509);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(89513);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./src/components/Splash/Scribe/AudioPlayer.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40px;\n  height: 40px;\n  background-color: #fafafa;\n  border: 2px solid #fafafa;\n  cursor: pointer;\n  outline: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  height: 10px;\n  width: 140px;\n  background-color: #f2f2f2;\n  margin: 0 10px;\n  position: relative;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  background-color: #000;\n  transition: width 0.3s ease;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var AudioPlayer = function(param) {
    var src = param.src;
    var audioRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), playing = ref[0], setPlaying = ref[1];
    var ref1 = (0,react.useState)(0), progress = ref1[0], setProgress = ref1[1];
    var togglePlay = function() {
        if (audioRef.current) {
            if (playing) {
                audioRef.current.pause();
            } else {
                audioRef.current.play();
            }
            setPlaying(!playing);
        }
    };
    (0,react.useEffect)(function() {
        var handleTimeUpdate = function() {
            if (audioRef.current) {
                var percentage = audioRef.current.currentTime / audioRef.current.duration * 100;
                setProgress(percentage);
            }
        };
        if (audioRef.current) {
            audioRef.current.addEventListener("timeupdate", handleTimeUpdate);
        }
        return function() {
            if (audioRef.current) {
                audioRef.current.removeEventListener("timeupdate", handleTimeUpdate);
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AudioPlayerContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayButton, {
                onClick: togglePlay,
                children: playing ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: "20",
                    height: "25",
                    viewBox: "0 0 20 31",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "0",
                            y: "0",
                            width: "7",
                            height: "31",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "13",
                            y: "0",
                            width: "7",
                            height: "31",
                            fill: "black"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "20",
                    height: "25",
                    viewBox: "0 0 20 31",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0 0 L20 15.5 L0 31 L0 0",
                        fill: "black"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBarContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar, {
                    style: {
                        width: "".concat(progress, "%")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("audio", {
                ref: audioRef,
                src: src,
                onEnded: function() {
                    return setPlaying(false);
                }
            })
        ]
    });
};
/* harmony default export */ var Scribe_AudioPlayer = (AudioPlayer);
var AudioPlayerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d76a3647-0"
})(_templateObject());
var PlayButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-d76a3647-1"
})(_templateObject1());
var ProgressBarContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d76a3647-2"
})(_templateObject2());
var ProgressBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d76a3647-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/Splash/Scribe/RecordingIcon.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
var RecordingIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "25",
        viewBox: "0 0 20 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.199219 15.2604C0.199219 20.6303 3.74717 24.3975 8.96635 24.8358V28.0276H3.88415C3.30881 28.0276 2.84306 28.4933 2.84306 29.0687C2.84306 29.644 3.30881 30.0961 3.88415 30.0961H16.1171C16.6924 30.0961 17.1581 29.644 17.1581 29.0687C17.1581 28.4933 16.6924 28.0276 16.1171 28.0276H11.0348V24.8358C16.2677 24.3975 19.802 20.6303 19.802 15.2604V12.4796C19.802 11.9043 19.3499 11.4522 18.7746 11.4522C18.1992 11.4522 17.7335 11.9043 17.7335 12.4796V15.1782C17.7335 19.8495 14.6923 22.9453 10.0074 22.9453C5.30881 22.9453 2.26771 19.8495 2.26771 15.1782V12.4796C2.26771 11.9043 1.81565 11.4522 1.22662 11.4522C0.651274 11.4522 0.199219 11.9043 0.199219 12.4796V15.2604ZM10.0074 20.0001C12.7335 20.0001 14.569 17.959 14.569 15.0413V5.87688C14.569 2.94536 12.7335 0.917969 10.0074 0.917969C7.26771 0.917969 5.4321 2.94536 5.4321 5.87688V15.0413C5.4321 17.959 7.26771 20.0001 10.0074 20.0001Z",
            fill: "black"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Splash/Scribe/TranscriptionDemo.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


function TranscriptionDemo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n"
    ]);
    TranscriptionDemo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TranscriptionDemo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 200px;\n  height: 150px;\n  border: 1px solid black;\n  background-color: white;\n  padding: 10px;\n  overflow-y: auto; // Make it scrollable vertically\n  font-family: Syne;\n"
    ]);
    TranscriptionDemo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TranscriptionDemo_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80px;\n  height: 80px;\n  background-color: #fff;\n  border: 1px solid #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  outline: none;\n\n  &:hover {\n    background-color: #f7f7f7;\n  }\n\n  &:active {\n    background-color: #e5e5e5;\n  }\n\n  svg {\n    width: 40px;\n    height: 40px;\n  }\n"
    ]);
    TranscriptionDemo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TranscriptionDemo_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 20px;\n  height: 20px;\n  background-color: #eb4730;\n"
    ]);
    TranscriptionDemo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



 // Adjust the path based on your directory structure

var TranscriptionDemo = function() {
    var mediaRecorder = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), recording = ref[0], setRecording = ref[1];
    var ref1 = (0,react.useState)(null), audioBlob = ref1[0], setAudioBlob = ref1[1];
    var ref2 = (0,react.useState)(null), transcription = ref2[0], setTranscription = ref2[1];
    var startRecording = function() {
        navigator.mediaDevices.getUserMedia({
            audio: true
        }).then(function(stream) {
            mediaRecorder.current = new MediaRecorder(stream);
            // Only set the audio blob here. Don't call uploadAudio directly.
            mediaRecorder.current.ondataavailable = function(event) {
                setAudioBlob(event.data);
            };
            mediaRecorder.current.start();
            setRecording(true);
        });
    };
    var stopRecording = function() {
        if (mediaRecorder.current) {
            mediaRecorder.current.stop();
            setRecording(false);
        }
    };
    (0,react.useEffect)(function() {
        if (audioBlob) {
            uploadAudio();
        }
    }, [
        audioBlob
    ]);
    var uploadAudio = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var formData, response, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (audioBlob) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        formData = new FormData();
                        formData.append("file", audioBlob);
                        _ctx.next = 6;
                        return fetch("".concat("https://api.vht.ac", "/demo/transcribe"), {
                            method: "POST",
                            body: formData
                        });
                    case 6:
                        response = _ctx.sent;
                        _ctx.next = 9;
                        return response.json();
                    case 9:
                        result = _ctx.sent;
                        if (result.text) {
                            setTranscription(result.text);
                        } else {
                            console.error("No transcription found");
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function uploadAudio() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterContainer, {
                children: recording ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecordingButton, {
                    onClick: stopRecording,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackSquare, {}),
                        " "
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordingButton, {
                    onClick: startRecording,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordingIcon, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterContainer, {
                children: audioBlob && /*#__PURE__*/ (0,jsx_runtime.jsx)(Scribe_AudioPlayer, {
                    src: URL.createObjectURL(audioBlob)
                })
            }),
            audioBlob && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBox, {
                children: transcription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: transcription
                })
            })
        ]
    });
};
/* harmony default export */ var Scribe_TranscriptionDemo = (TranscriptionDemo);
var CenterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8d3da2c-0"
})(TranscriptionDemo_templateObject());
var TextBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8d3da2c-1"
})(TranscriptionDemo_templateObject1());
var RecordingButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-b8d3da2c-2"
})(TranscriptionDemo_templateObject2());
var BlackSquare = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8d3da2c-3"
})(TranscriptionDemo_templateObject3());

;// CONCATENATED MODULE: ./src/pages/meta/scribe/index.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function scribe_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #fafafa;\n  min-height: 100vh;\n"
    ]);
    scribe_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function scribe_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px;\n"
    ]);
    scribe_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function scribe_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "Syne", sans-serif;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  color: #333;\n  &:hover {\n    text-decoration: underline;\n  }\n'
    ]);
    scribe_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function scribe_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  padding-bottom: 0;\n  text-align: center;\n"
    ]);
    scribe_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  background-color: black; // Set background color to black\n  color: white; // Set font color to white\n  text-align: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  text-align: center;\n  background-color: #fafafa; // Same as the first and second sections\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  text-align: center;\n  background-color: #fafafa; // Adjust as needed\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  background-image: url("https://vienna-prod.imgix.net/7518abb4-25e3-4f4e-ae0b-8f0448b4b2b9.svg?auto=format");\n  background-size: contain; // to make sure the image fits into the div\n  background-repeat: no-repeat; // to prevent image tiling\n  background-position: center; // to center the image\n  width: 130px;\n  height: 44.32px;\n  cursor: pointer; // to indicate the div is clickable\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: flex-start; // align to the top of the container\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 0;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 24px;\n  font-weight: unset;\n  left: 50%;\n  font-family: "ViennaGaramondLight-Regular";\n  user-select: none;\n\n  @media only screen and (min-width: 768px) {\n    font-size: 32px;\n  }\n\n  @media only screen and (min-width: 1024px) {\n    font-size: 40px;\n  }\n'
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 55px; // Set to your mobile size\n  margin-bottom: 30px;\n  font-family: "ViennaGaramondLight-Italic";\n\n  @media only screen and (min-width: 768px) {\n    font-size: 65px; // Set to your tablet size or adjust as needed\n  }\n\n  @media only screen and (min-width: 1024px) {\n    font-size: 100px; // Set to your desktop size or adjust as needed\n  }\n'
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 55px; //set for mobiel size\n  margin-bottom: 20px;\n  font-family: "ViennaGaramondLight-Regular";\n  color: gray;\n  margin-bottom: -5px;\n\n  @media only screen and (min-width: 768px) {\n    font-size: 65px; // Set to your tablet size or adjust as needed\n  }\n\n  @media only screen and (min-width: 1024px) {\n    font-size: 100px; // Set to your desktop size or adjust as needed\n  }\n'
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 16px;\n  margin-bottom: 10px;\n  font-family: "Syne", sans-serif;\n  @media only screen and (min-width: 768px) {\n    font-size: 19px; // Tablet Size\n  }\n\n  @media only screen and (min-width: 1024px) {\n    font-size: 19px; // Desktop Size\n  }\n'
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 1px;\n  background-color: black;\n  width: 100%;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 40px; // Adjust as needed\n  margin-bottom: 20px;\n  font-family: "ViennaGaramondLight-Regular";\n  @media only screen and (min-width: 768px) {\n    font-size: 45px; // Tablet Size\n  }\n\n  @media only screen and (min-width: 1024px) {\n    font-size: 50px; // Desktop Size\n  }\n'
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  background-image: url("https://vienna-prod.imgix.net/d56a5238-367b-4471-bdd8-aa378ee682e6.png?auto=format");\n  background-size: cover; // this will make sure your image covers the div completely\n  background-position: center; // this will center your image in the div\n  background-repeat: no-repeat; // this will prevent your image from repeating in the div\n  width: 162px;\n  height: 162px;\n  margin-bottom: 20px;\n\n  @media only screen and (min-width: 768px) {\n    width: 182px; // Tablet Size\n    height: 182px;\n  }\n\n  @media only screen and (min-width: 1024px) {\n    width: 220px; // Desktop Size\n    height: 220px;\n  }\n'
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 40px;\n  margin-bottom: 10px;\n  font-family: "ViennaGaramondLight-Regular";\n\n  @media only screen and (min-width: 768px) {\n    font-size: 45px; // Tablet Size\n  }\n\n  @media only screen and (min-width: 1024px) {\n    font-size: 50px; // Desktop Size\n  }\n'
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 40px;\n  margin-bottom: 0px;\n  color: gray;\n  font-family: "ViennaGaramondLight-Regular";\n\n  @media only screen and (min-width: 768px) {\n    font-size: 45px; // Tablet Size\n  }\n\n  @media only screen and (min-width: 1024px) {\n    font-size: 50px; // Desktop Size\n  }\n'
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: right;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: left;\n  padding-left: 10px;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 40px; // Adjust as needed\n  margin-bottom: 20px;\n  color: white;\n  font-family: "ViennaGaramondLight-Regular";\n\n  @media only screen and (min-width: 768px) {\n    font-size: 45px; // Tablet Size\n  }\n\n  @media only screen and (min-width: 1024px) {\n    font-size: 50px; // Desktop Size\n  }\n'
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 40px; // Adjust as needed\n  margin-bottom: -3px;\n  color: gray;\n  font-family: "ViennaGaramondLight-Regular";\n  @media only screen and (min-width: 768px) {\n    font-size: 45px; // Tablet Size\n  }\n\n  @media only screen and (min-width: 1024px) {\n    font-size: 50px; // Desktop Size\n  }\n'
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 35px; // Adjust as needed\n  margin-bottom: -3px;\n  color: black;\n  font-family: "ViennaGaramondLight-Regular";\n  @media only screen and (min-width: 768px) {\n    font-size: 40px; // Tablet Size\n  }\n\n  @media only screen and (min-width: 1024px) {\n    font-size: 45px; // Desktop Size\n  }\n'
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 35px; // Adjust as needed\n  margin-bottom: -3px;\n  color: gray;\n  font-family: "ViennaGaramondLight-Regular";\n  @media only screen and (min-width: 768px) {\n    font-size: 40px; // Tablet Size\n  }\n\n  @media only screen and (min-width: 1024px) {\n    font-size: 45px; // Desktop Size\n  }\n'
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  background-image: url("https://vienna-prod.imgix.net/51f2ba9d-6d56-4d6a-babb-83de0434cb17.svg?auto=format");\n  background-size: contain; // to make sure the image fits into the div\n  background-repeat: no-repeat; // to prevent image tiling\n  background-position: center; // to center the image\n  width: 100px; // Adjust as needed\n  height: 100px; // Adjust as needed\n  margin: 20px auto; // Center the image and give it some margin from top and bottom\n'
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  padding: 0;\n  margin: 10px 0;\n  background-color: #fafafa;\n  border: 0px solid #ccc;\n  max-width: 400px;\n\n  li {\n    padding: 10px;\n    border-bottom: 1px solid #fafafa;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    &:hover {\n      background-color: #fafafa;\n    }\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  color: black; // adjust the color to fit your design\n  text-decoration: underline;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}





function ViennaScribeHome() {
    var ref = (0,react.useState)(false), isDropdownVisible = ref[0], setDropdownVisibility = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Vienna Scribe"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "Scribe."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://vienna.earth/meta/",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeButton, {
                                    children: "Home"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GrayHeader, {
                                children: "Transcription"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackHeader, {
                                children: "Transformed"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(scribe_CenterContainer, {
                                style: {
                                    marginTop: "5px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://apps.apple.com/us/app/vienna-scribe/id6444012049",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadButton, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(scribe_CenterContainer, {
                                style: {
                                    marginBottom: "0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    style: {
                                        width: "100%",
                                        maxWidth: "475px"
                                    },
                                    src: "https://vienna-prod.imgix.net/754d4b3a-cde6-42f0-83a6-d150cfce9b37.png",
                                    alt: "Screenshot",
                                    draggable: "false"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackLine, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FirstSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySubtitle, {
                                style: {
                                    marginTop: "30px"
                                },
                                children: "Precision,"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackSubtitle, {
                                children: "to the point."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(scribe_CenterContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Scribe_TranscriptionDemo, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackLine, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecondSection, {
                        style: {
                            paddingBottom: "0px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySubtitle, {
                                style: {
                                    marginTop: "30px"
                                },
                                children: "Perfect transcription,"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackSubtitle, {
                                children: "within reach."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(scribe_CenterContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenImage, {
                                    style: {
                                        marginTop: "25px",
                                        marginBottom: "25px"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnsContainer, {
                                style: {
                                    marginBottom: "40px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Column, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GaramondBlackListTextRightAlign, {
                                            children: "For every"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GaramondGrayListTextLeftAlign, {
                                                children: "Diagnosis"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GaramondGrayListTextLeftAlign, {
                                                children: "Meeting"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GaramondGrayListTextLeftAlign, {
                                                children: "Lecture"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GaramondGrayListTextLeftAlign, {
                                                children: "Interview"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GaramondGrayListTextLeftAlign, {
                                                children: "Meditation"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GaramondGrayListTextLeftAlign, {
                                                children: "Memory"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GaramondGrayListTextLeftAlign, {
                                                children: "Idea"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThirdSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySubtitle, {
                                style: {
                                    marginTop: "75px"
                                },
                                children: "Locked-down"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhiteSubtitle, {
                                children: "Privacy"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhiteImage, {
                                style: {
                                    marginTop: "25px",
                                    marginBottom: "25px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySubtitle, {
                                children: "Files stored"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySubtitle, {
                                style: {
                                    marginBottom: "25px"
                                },
                                children: "on device."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySubtitle, {
                                children: "Completely"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySubtitle, {
                                style: {
                                    marginBottom: "90px"
                                },
                                children: "Anonymous."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FourthSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallBlackSubtitle, {
                                style: {
                                    marginTop: "40px"
                                },
                                children: "70+ Languages"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallGraySubtitle, {
                                style: {
                                    marginBottom: "10px"
                                },
                                children: "automatically detected"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownTrigger, {
                                onClick: function() {
                                    return setDropdownVisibility(!isDropdownVisible);
                                },
                                children: isDropdownVisible ? "hide all" : "see all"
                            }),
                            isDropdownVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(scribe_CenterContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Afrikaans, Arabic, Armenian, Azerbaijani"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Belarusian, Bosnian, Bulgarian, Catalan"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Chinese, Croatian, Czech, Danish"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Dutch, English, Estonian, Finnish"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "French, Galician, German, Greek"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Hebrew, Hindi, Hungarian, Icelandic"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Indonesian, Italian, Japanese, Kannada"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Kazakh, Korean, Latvian, Lithuanian"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Macedonian, Malay, Marathi, Maori"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Nepali, Norwegian, Persian, Polish"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Portuguese, Romanian, Russian, Serbian"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Slovak, Slovenian, Spanish, Swahili"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Swedish, Tagalog, Tamil, Thai, Turkish"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: "Ukrainian, Urdu, Vietnamese, Welsh"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallBlackSubtitle, {
                                style: {
                                    marginTop: "50px"
                                },
                                children: "Supported Files,"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallGraySubtitle, {
                                style: {
                                    marginBottom: "10px"
                                },
                                children: "easily importable"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                children: "mp3, mp4, m4a,wav,webm"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallBlackSubtitle, {
                                style: {
                                    marginTop: "50px"
                                },
                                children: "Exportable Text"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallGraySubtitle, {
                                style: {
                                    marginBottom: "10px"
                                },
                                children: "with format promting"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                style: {
                                    marginBottom: "60px"
                                },
                                children: "for emails, summaries, blogposts and more."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackLine, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FifthSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySubtitle, {
                                style: {
                                    marginTop: "25px"
                                },
                                children: "Simple &"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackSubtitle, {
                                style: {
                                    marginBottom: "50px"
                                },
                                children: "Unlimited"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                style: {
                                    marginBottom: "55px"
                                },
                                children: "$9.99 per month."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(scribe_CenterContainer, {
                                style: {
                                    marginBottom: "50px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://apps.apple.com/us/app/vienna-scribe/id6444012049",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadButton, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://vienna.earth/meta/scribe/faq",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    style: {
                                        marginTop: "50px"
                                    },
                                    children: "FAQ"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://vienna.earth/meta/scribe/privacy",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    children: "Privacy Policy"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://vienna.earth/meta/scribe/accuracy",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    children: "Testing Details"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// Layout
var Main = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    componentId: "sc-2a5362d0-0"
})(scribe_templateObject());
var Navbar = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-2a5362d0-1"
})(scribe_templateObject1());
var HomeButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-2a5362d0-2"
})(scribe_templateObject2());
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-2a5362d0-3"
})(scribe_templateObject3());
var FirstSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-2a5362d0-4"
})(_templateObject4());
var SecondSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-2a5362d0-5"
})(_templateObject5());
var ThirdSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-2a5362d0-6"
})(_templateObject6());
var FourthSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-2a5362d0-7"
})(_templateObject7());
var FifthSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-2a5362d0-8"
})(_templateObject8());
var DownloadButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-9"
})(_templateObject9());
var scribe_CenterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-10"
})(_templateObject10());
var ColumnsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-11"
})(_templateObject11());
var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-12"
})(_templateObject12());
// Typography
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-2a5362d0-13"
})(_templateObject13());
var Placeholder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-14"
})(_templateObject14());
var BlackHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-15"
})(_templateObject15());
var GrayHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-16"
})(_templateObject16());
var Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2a5362d0-17"
})(_templateObject17());
var BlackLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-18"
})(_templateObject18());
var BlackSubtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-19"
})(_templateObject19());
var GreenImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-20"
})(_templateObject20());
var GaramondBlackListText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-21"
})(_templateObject21());
var GaramondGrayListText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-22"
})(_templateObject22());
var GaramondBlackListTextRightAlign = (0,styled_components_browser_esm/* default */.ZP)(GaramondBlackListText).withConfig({
    componentId: "sc-2a5362d0-23"
})(_templateObject23());
var GaramondGrayListTextLeftAlign = (0,styled_components_browser_esm/* default */.ZP)(GaramondGrayListText).withConfig({
    componentId: "sc-2a5362d0-24"
})(_templateObject24());
var WhiteSubtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-25"
})(_templateObject25());
var GraySubtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-26"
})(_templateObject26());
var SmallGraySubtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-27"
})(_templateObject27());
var SmallBlackSubtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-28"
})(_templateObject28());
//images
var WhiteImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a5362d0-29"
})(_templateObject29());
var Dropdown = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-2a5362d0-30"
})(_templateObject30());
var DropdownTrigger = (0,styled_components_browser_esm/* default */.ZP)(Text).withConfig({
    componentId: "sc-2a5362d0-31"
})(_templateObject31());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(19341); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);